import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import DisplayWindow from '../DisplayWindow';
import TopBar from '../TopBar';

const Layout =({children}: any) =>{
    const [personnel, setPersonnel] = useState('Admin');

    return(
        <>
            <div className="layout-container">
                <Sidebar setPersonnel={setPersonnel}/>
                <div className="layout-content">
                    <TopBar  personnel={personnel}/>
                    <DisplayWindow>
                        {children}
                    </DisplayWindow>
                </div>
            </div>
        </>
    )
}

export default Layout;
